import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrash, faEdit, faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import './RowEditor.css'

const SEPARATORS = ['.', '!', '?']

export function getSentences(row, rowIndex) {
  const separators = row
    .map((cell, cellIndex) => [cell, cellIndex])
    .filter(cellc => SEPARATORS.includes(cellc[0]))
  let prevIndex = 0
  const sentences = []
  separators.forEach(cellc => {
    sentences.push({
      rowIndex,
      beginIndex: prevIndex,
      endIndex: cellc[1] + 1,
      cells: row.slice(prevIndex, cellc[1] + 1)
    })
    prevIndex = cellc[1] + 1
  })
  if (prevIndex < row.length) {
    sentences.push({
      rowIndex,
      beginIndex: prevIndex,
      endIndex: row.length,
      cells: row.slice(prevIndex)
    })
  }
  return sentences
}

export class RowEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cell: null,
      row: null,
      sentence: false,
      updating: false,
      logContext: null,
      shares: null,
      deleteConfirm: false,
      deleting: false,
      restoring: false,
      report: false,
    }
    this.logUrlRef = React.createRef();
  }

  copyState() {
    const state = Object.assign({}, this.state)
    state.cell = state.cell === null ? null : Object.assign({}, state.cell)
    state.row = state.row === null ? null : Object.assign({}, state.row)
    return state
  }

  renderEditor(sentence) {
    return sentence.cells.map((cell, cellIndex) =>
      cell.match(/^!([^#]+)(#.+)?$/) ?
        <span key={cellIndex} className='PageCell'>{cell.match(/^!([^#]+)(#.+)?$/)[1]}:</span> :
        <span key={cellIndex}>
          {this.hasSpace(sentence.cells, cellIndex) && ' '}
          {!this.isEditable(cell, cellIndex) ?
            <span>
              {cell}
            </span> :
            <span
              onClick={ev => this.startEdit(sentence, cellIndex)}
              className={`CellEditor ${cell.split('|').length > 1 ? 'ProblemCell' : 'DefaultCell'}`}
            >
              {cell}
            </span>}
        </span>
    )
  }

  cellTypeChange(event) {
    const state = this.copyState()
    let selectables = state.cell.text.split('|').slice(1)
    if (selectables.length === 1 && selectables[0] === '*') {
      selectables = []
    }
    let newValue = state.cell.text
    if (event.target.value === '') {
      newValue = state.cell.text.split('|')[0]
      if (selectables.length > 0) {
        state.cell.selectable = selectables
      }
    } else if (event.target.value === 'text') {
      newValue = `${state.cell.text.split('|')[0]}|*`
      if (selectables.length > 0) {
        state.cell.selectable = selectables
      }
    } else if (event.target.value === 'selectable') {
      newValue = [state.cell.text.split('|')[0]].concat((state.cell.selectable || []).length > 0 ? state.cell.selectable : ['some', 'any']).join('|')
    }
    state.cell.text = newValue
    this.setState(state, () => {
      const newRow = this.props.row.map(v => v)
      newRow[state.cell.sentence.beginIndex + state.cell.index] = newValue

      if (!this.props.onChange) {
        return
      }
      this.props.onChange(this.props.rowIndex, newRow)
    })
  }

  selectableChange(textIndex, event) {
    const values = this.state.cell.text.split('|')
    values[textIndex + 1] = event.target.value
    this.updateDataText(values.join('|'))
  }

  addSelectable(event) {
    this.updateDataText(`${this.state.cell.text}|`)
  }

  removeSelectable(textIndex, event) {
    const values = this.state.cell.text.split('|')
    values[textIndex + 1] = null
    this.updateDataText(values.filter(v => v !== null).join('|'), this.state.cell.revision + 1)
  }

  updateDataText(newValue, revision) {
    const state = this.copyState()
    state.cell.text = newValue
    state.cell.revision = revision || state.cell.revision
    this.setState(state)
  }

  startEdit(sentence, cellIndex) {
    this.setState({
      cell: {
        sentence,
        index: cellIndex,
        text: sentence.cells[cellIndex],
        selectable: [],
        revision: 1,
      }
    })
  }

  closeEdit() {
    const state = this.copyState()
    const lastCell = state.cell
    state.cell = null
    this.setState(state, () => {
      const newRow = this.props.row.map(v => v)
      newRow[lastCell.sentence.beginIndex + lastCell.index] = lastCell.text

      if (!this.props.onChange) {
        return
      }
      this.props.onChange(this.props.rowIndex, newRow)
    })
  }

  editRow() {
    const state = this.copyState()
    let text = ''
    const row = this.props.image ? this.props.row.slice(1) : this.props.row
    row.forEach((cell, cellIndex) => {
      if (this.hasSpace(row, cellIndex)) {
        text += ' '
      }
      text += cell.split('|')[0]
    })
    state.row = {
      edit: true,
      text,
    }
    this.setState(state)
  }

  addRow() {
    const state = this.copyState()
    state.row = {
      edit: false,
      text: '',
    }
    this.setState(state)
  }

  submitRow() {
    const state = this.copyState()
    const lastRow = state.row
    state.submitting = true
    this.setState(state)

    const handler = lastRow.edit ? this.props.onEdit : this.props.onAdd
    if (!handler) {
      return
    }
    handler(
      this.props.rowIndex,
      lastRow.text.replace(/(\r\n|\n|\r)/gm, ' '),
      () => {
        this.setState({
          row: null,
          submitting: false,
        })
    })
  }

  deleteRow() {
    if (!this.props.onDelete) {
      return
    }
    this.props.onDelete(this.props.rowIndex)
  }

  toNext() {
    if (!this.props.onToNext) {
      return
    }
    this.props.onToNext(this.props.rowIndex)
  }

  toPrev() {
    if (!this.props.onToPrev) {
      return
    }
    this.props.onToPrev(this.props.rowIndex)
  }

  rowTextChange(event) {
    const state = this.copyState()
    state.row.text = event.target.value
    this.setState(state)
  }

  closeRowEdit() {
    const state = this.copyState()
    state.row = null
    this.setState(state)
  }

  isEditable(cell, cellIndex) {
    return cell.match(/^[a-zA-Z0-9\|\*]+$/)
  }

  hasSpace(cells, cellIndex) {
    if (cellIndex <= 0) {
      return false
    }
    const cell = cells[cellIndex]
    if (SEPARATORS.includes(cell)) {
      return false
    }
    if ([',', ':', ';'].includes(cell)) {
      return false
    }
    if (cell.match(/^(\.+|\!+|\?+)$/)) {
      return false
    }
    if (cell.match(/^\'.+$/)) {
      return false
    }
    if (cells[cellIndex - 1].match(/^(\(|\[|\{)$/)) {
      return false
    }
    if (cell.match(/^(\)|\]|\})$/)) {
      return false
    }
    if (cell.match(/^(\"|\')$/)) {
      const quote = cell
      const previous = cells.slice(0, cellIndex).filter(c => c === quote)
      if (previous.length % 2 === 1) {
        return false
      }
    }
    if (cells[cellIndex - 1].match(/^(\"|\')$/)) {
      const quote = cell
      const previous = cells.slice(0, cellIndex - 1).filter(c => c === quote)
      if (previous.length % 2 === 0) {
        return false
      }
    }
    return true
  }

  renderModals() {
    const cellText = this.state.cell ? this.state.cell.text : ''
    let selectables = cellText.split('|').slice(1)
    if (selectables.length === 1 && selectables[0] === '*') {
      selectables = []
    }
    const cellEditor = <Modal
      data-test-cell-modal-detail
      show={this.state.cell !== null}
      animation={true}
      onHide={e => this.closeEdit()}>
      <Modal.Header closeButton>
        <Modal.Title>"{cellText.split('|')[0]}" の編集</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>空欄タイプ</Form.Label>
          <Form.Control
            data-test-cell-mode
            as='select'
            onChange={ev => this.cellTypeChange(ev)}
            value={!cellText.includes('|') ? '' : (selectables.length === 0 ? 'text' : 'selectable')}>
            <option value=''>空欄にしない</option>
            <option value='text'>自由記述</option>
            <option value='selectable'>選択式</option>
          </Form.Control>
        </Form.Group>
        {selectables.map((text, textIndex) =>
          <Form.Group key={`${this.state.cell ? this.state.cell.revision : 0}-${textIndex}`}>
            <Form.Label>候補{textIndex + 1}</Form.Label>
            <Form.Control
              placeholder='単語候補'
              defaultValue={text}
              onChange={e => this.selectableChange(textIndex, e)} />
            <Button
              variant='light'
              data-test-cell-selectable-remove
              onClick={e => this.removeSelectable(textIndex, e)}>
              <FontAwesomeIcon icon={faTrash} />
              削除
            </Button>
          </Form.Group>)}
        {selectables.length > 0 &&
          <Button
            variant='light'
            data-test-cell-selectable-add
            onClick={e => this.addSelectable(e)}>
            <FontAwesomeIcon icon={faPlus} />
            候補追加
          </Button>}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='light'
          data-test-cell-detail-close
          onClick={e => this.closeEdit(e)}>
          閉じる
        </Button>
      </Modal.Footer>
    </Modal>
    const rowEditor = <Modal
      data-test-row-modal-detail
      show={this.state.row !== null}
      animation={true}
      onHide={e => this.closeRowEdit()}>
      <Modal.Header closeButton>
        <Modal.Title>段落の編集</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {this.state.row && this.state.row.edit && <p>
            段落文字列を編集すると、選択肢の情報はリセットされます。
          </p>}
        <Form.Group>
          <Form.Label>段落文字列(改行は無視されます)</Form.Label>
          <Form.Control
            as='textarea'
            name='text'
            rows='10'
            defaultValue={this.state.row && this.state.row.text}
            placeholder='ここに英語の文章を入力してください。'
            onChange={ev => this.rowTextChange(ev)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='light'
          data-test-row-detail-close
          onClick={e => this.closeRowEdit(e)}>
          閉じる
        </Button>
        <Button
          variant='primary'
          data-test-row-detail-submit
          disabled={this.state.submitting}
          onClick={e => this.submitRow(e)}>
          {this.state.submitting ? '解析中...' : (this.state.row && this.state.row.edit ? '編集' : '追加')}
        </Button>
      </Modal.Footer>
    </Modal>
    return <div>
      {cellEditor}
      {rowEditor}
    </div>
  }

  renderType(data) {
    if (!data) {
      return null
    }
    const content = JSON.parse(data)
    return content.type
  }

  renderReport(data) {
    if (!data) {
      return null
    }
    const content = JSON.parse(data)
    return `${content.text} - 開始位置:${content.progress.detail.selected.beginIndex}`
  }

  changeResolved(logId, event) {
    console.log('RESOLVED', logId, event.target.value)
    if (!this.props.onResolve) {
      return
    }
    this.props.onResolve(logId, event.target.value === 'on')
  }

  renderSentenceEditors(row, rowIndex) {
    const sentences = getSentences(row, rowIndex)
    const rowEditor = <span className='RowTools'>
      <Button
        data-test-edit-row
        onClick={e => this.editRow()}
        title='段落の編集'
        variant='light'>
        <FontAwesomeIcon icon={faEdit} />
      </Button>
      {!this.props.image && <span>
        <Button
          data-test-delete-row
          onClick={e => this.deleteRow()}
          title='段落の削除'
          variant='light'>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
        <Button
          data-test-add-row
          onClick={e => this.addRow()}
          title='段落の追加'
          variant='light'>
          <FontAwesomeIcon icon={faPlus} />
        </Button>
      </span>}
      {this.props.hasToPrev && <Button
        data-test-to-prev
        onClick={e => this.toPrev()}
        title='段落順序を前に移動'
        variant='light'>
        <FontAwesomeIcon icon={faArrowUp} />
      </Button>}
      {this.props.hasToNext && <Button
        data-test-to-next
        onClick={e => this.toNext()}
        title='段落順序を後ろに移動'
        variant='light'>
        <FontAwesomeIcon icon={faArrowDown} />
      </Button>}
      {this.props.issueLogs && this.props.issueLogs.length > 0 && <Button
        data-test-check-issue
        onClick={e => this.setState({
          report: !this.state.report,
        })}
        variant='light'>
        {this.state.report ? '問題を非表示 ' : '問題を表示 '}
        {this.props.issueLogs.filter(l => l.data.resolved).length > 0 && <span>
          <Badge variant='light'>{this.props.issueLogs.filter(l => l.data.resolved).length}</Badge>{' '}
        </span>}
        {this.props.issueLogs.filter(l => !l.data.resolved).length > 0 && <span>
          <Badge variant='danger'>{this.props.issueLogs.filter(l => !l.data.resolved).length}</Badge>{' '}
        </span>}
      </Button>}
    </span>
    return sentences.map((sentence, sentenceIndex) =>
      <div key={sentenceIndex} className='Sentence'>
        {this.renderEditor(sentence)}
        {sentenceIndex === sentences.length - 1 && rowEditor}
      </div>)
  }

  render() {
    return <div>
      {this.renderSentenceEditors(this.props.row, this.props.rowIndex)}
      {this.state.report && <Table striped bordered hover>
        <thead>
          <tr>
            <th>報告日</th>
            <th>報告者</th>
            <th>タイプ</th>
            <th>内容</th>
            <th>解決</th>
          </tr>
        </thead>
        <tbody>
          {(this.props.issueLogs || []).map(log => <tr key={log.id}>
              <td>{moment(new Date(log.data.finished)).format()}</td>
              <td>{log.data.user}</td>
              <td>{this.renderType(log.data.data)}</td>
              <td>{this.renderReport(log.data.data)}</td>
              <td>
                <Form.Check
                  type='checkbox'
                  onChange={(ev) => this.changeResolved(log.id, ev)}
                  label=''
                  checked={log.data.resolved === true}
                />
              </td>
            </tr>)}
        </tbody>
      </Table>}
      {this.renderModals()}
    </div>
  }
}
